var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{},[_vm._m(0),_vm._v(" "),_c('router-view',{attrs:{"name":"headerLight"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"headerDark"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skip-nav"},[_c('a',{attrs:{"href":"#content"}},[_vm._v("Skip to main content")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20037320","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 412
// module chunks = 0